module.exports = __webpack_public_path__ + "img/footer-link-2.f399e958.svg";